import {createFileRoute} from '@tanstack/react-router'
import {useState} from "react";
import {Card, Radio, Typography} from "antd";
import {FocusRover} from "@/components/focusrover/FocusRover.tsx";
import classNames from "classnames";

export const Route = createFileRoute('/dev_/radiogroup')({
  component: RouteComponent,
})

type Option = {
  id: number,
  name: string,
}

function RouteComponent() {

  const options: Option[] = [];

  const [selectedOption, setSelectedOption] = useState<number | null>(null);

  let i: number = 0;
  for (i; i <= 10; i++) {
    options.push({
      id: i,
      name: "Option-Name-" + i,
    })
  }

  return (<div>
    <Typography.Title level={5}>Hello "/dev_/radiogroup"!</Typography.Title>
    <FocusRover itemSelector='input[type="radio"]' activeValue={selectedOption}>
      <Radio.Group name="payment" id={"x"} value={selectedOption}>
        {options.map((option) => (
            <Card key={`key-${option.id}`} className={classNames(
                {"is-selected": selectedOption === option.id}
            )}>
              <Radio value={option.id}
                     onClick={() => setSelectedOption(option.id)}
              >{option.name}</Radio>
            </Card>
        ))}
      </Radio.Group>
    </FocusRover>
  </div>);
}
